import {
  UPLOAD_POLICIES,
  UPLOAD_PURPOSE_MARKETPLACE_CUSTOM_ASSET,
} from "@nexus/contracts";

const MB = 1024 * 1024;

const CONTENT_TYPE_LABEL: Record<string, string> = {
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document": "DOCX",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": "XLSX",
};

function formatMegabytes(bytes: number): string {
  return `${Math.round(bytes / MB)} MB`;
}

/** User-facing upload limits derived from the marketplace custom-asset upload policy. */
export function getMarketplaceCustomAssetUploadConstraints(): {
  formats: string;
  accept: string;
  maxSize: string;
} {
  const policy = UPLOAD_POLICIES[UPLOAD_PURPOSE_MARKETPLACE_CUSTOM_ASSET];
  const formats = policy.allowedContentTypes
    .map((contentType) => CONTENT_TYPE_LABEL[contentType] ?? contentType)
    .join(", ");
  const maxBytes = Math.max(...Object.values(policy.maxSizeBytesByContentType));

  return {
    formats,
    accept: policy.allowedContentTypes.join(","),
    maxSize: formatMegabytes(maxBytes),
  };
}
